const unitOfMeasures = [
  { label: 'Bag', value: 'bag' },
  { label: 'Bottle', value: 'bottle' },
  { label: 'Carton', value: 'carton' },
  { label: 'Dozen', value: 'dozen' },
  { label: 'Drum', value: 'drum' },
  { label: 'Pack', value: 'pack' },
  { label: 'Pair', value: 'pair' },
  { label: 'Pieces', value: 'pieces' },
  { label: 'Each', value: 'each' },
  { label: 'Gram', value: 'gram' },
  { label: 'Kilogram', value: 'kilogram' },
  { label: 'Tonne', value: 'tonne' },
  { label: 'Liter', value: 'liter' },
]

export default unitOfMeasures
